// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0e1c8077","541":"955c3132","703":"eb0348b9","787":"624b3be9"}[chunkId] + ".chunk.js";
};